<template>
    <div>

        <template v-if="truckOrderDetail">
        <Row>{{truckOrderDetail.truckOrderNumber}} (<span :style="{color: getColor(truckOrderDetail.status)}">{{truckOrderDetail.status}}</span>)</Row>
        <Row :gutter="10" style="font-size: 15px">
            <Col :md="8">
              <Row :gutter="10">
                  <Col :md="8" style="color: #444444">Book Date</Col><Col span="1">:</Col>
                  <Col :md="12">{{moment(truckOrderDetail.bookingDate).format('DD MMM YYYY')}}</Col>
                  <Col :md="8" style="color: #444444">Route</Col><Col span="1">:</Col>
                  <Col :md="12">{{truckOrderDetail.fromCity}} - {{truckOrderDetail.toCity}}</Col>
                  <Col :md="8" style="color: #444444">Vehicle No</Col><Col span="1">:</Col>
                  <Col :md="12">{{truckOrderDetail.truck.platNo}}</Col>
                  <Col :md="8" style="color: #444444">Eway Bill No</Col><Col span="1">:</Col>
                  <Col :md="12">{{truckOrderDetail.ewayBillNo?truckOrderDetail.ewayBillNo:'-'}}</Col>
              </Row>
            </Col>
            <Col :md="8">
                <Row :gutter="10">
                    <Col :md="8" style="color: #444444">Committed Wt</Col><Col span="1">:</Col>
                    <Col :md="12">{{truckOrderDetail.commitedWeight?truckOrderDetail.commitedWeight:'-'}}</Col>
                    <Col :md="8" style="color: #444444">Rate</Col><Col span="1">:</Col>
                    <Col :md="12">₹{{truckOrderDetail.price?truckOrderDetail.price:'-'}} / Ton</Col>
                    <Col :md="8" style="color: #444444">LR Comm</Col><Col span="1">:</Col>
                    <Col :md="12">{{truckOrderDetail.lrCommision?truckOrderDetail.lrCommision:'-'}}</Col>
                    <Col :md="8" style="color: #444444">Appro. Payment</Col><Col span="1">:</Col>
                    <Col :md="12">{{(truckOrderDetail.commitedWeight*truckOrderDetail.price/1000)-truckOrderDetail.lrCommision}}</Col>
                </Row>
            </Col>
            <Col :md="8">
                <Row :gutter="10">
                    <Col :md="8" style="color: #444444">Driver Name</Col><Col span="1">:</Col>
                    <Col :md="12">{{truckOrderDetail.driverDetail.name}}</Col>
                    <Col :md="8" style="color: #444444">Driver Mobile</Col><Col span="1">:</Col>
                    <Col :md="12">{{truckOrderDetail.driverDetail.mobile}}</Col>
                    <Col :md="8" style="color: #444444">Transporter</Col><Col span="1">:</Col>
                    <Col :md="12">{{truckOrderDetail.Transporter.name}}</Col>
                </Row>
            </Col>
        </Row>
            <Divider></Divider>
        <Row :gutter="10">
            <Col :md="4">Total Orders: {{orders.length}}</Col>
            <Col :md="8">Status:
                <span style="cursor: pointer;text-decoration: underline" @click="openChangeStatusPopup">
                    {{truckOrderDetail.InternalStatus.name}}
                </span>
            </Col>
            <Col :md="7">Total / Com Wt: {{totalWtOfOrders}} / {{truckOrderDetail.commitedWeight}}
                <span :class="(totalWtOfOrders - truckOrderDetail.commitedWeight)>0?'plus-value':'minus-value'">
                    ({{Math.abs(totalWtOfOrders - truckOrderDetail.commitedWeight)}})
                </span>
            </Col>
            <Col :md="3"><Button @click="exportTruckDetailOrdersCSV">Export CSV</Button></Col>
            <Col :md="2"><Button @click="exportTruckDetailOrdersPDF">Export PDF</Button></Col>
        </Row>
        </template>

        <Spin fix size="small" v-if="!this.$route.params.id"></Spin>

        <hot-table :settings="hotSettings" ref="hotTableComponent" style="margin: 20px 0 0 0">
            <hot-column v-for="(colset, index) in columns" :settings="colset" :key="index">
                <component hot-editor hot-renderer v-bind:is="colset.component"></component>
            </hot-column>
        </hot-table>

        <Modal v-model="changeStatusPopup" title="Confirmation" draggable>
          <div slot="header">Update Truck Order Status</div>
           <template v-if="truckOrderDetail">
            <div v-if="truckOrderDetail.InternalStatus.id === Constants.internalStatus.waitingForDeparture">
                <template v-if="!orders.length">
                    <p style="color: red">No Orders assigned to it !</p>
                </template>
                <template v-else-if="!truckOrderDetail.ewayBillNo">
                    <p style="color: red">Please enter Eway Bill number</p>
                </template>
                <template v-else>
                    <Button @click.stop="onWayToDropCityWarehouse(truckOrderDetail.id, 'loader1')" :loading="loader1">
                        <span v-if="!loader1">Depart</span>
                        <span v-else>Loading...</span>
                    </Button>
                </template>

                <template v-if="errMessages.length">
                    <p style="margin:5px 0px">The Following Orders are still not in <i>'Waiting For Departure'</i> stage</p>
                    <ul style="color: red; margin: 10px">
                        <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>
                    </ul>
                </template>

            </div>

            <div v-if="truckOrderDetail.InternalStatus.id === Constants.internalStatus.onTheWayToDropCityWarehouse">
                <Button @click.stop="onAtDestinationCityWarehouse(truckOrderDetail.id, 'loader1')" :loading="loader1">
                    <span v-if="!loader1">Reached Destination City</span>
                    <span v-else>Loading...</span>
                </Button>
                <template v-if="errMessages.length">
                    <p style="margin:5px 0px">The Following Orders are still not in <i>'On The Way To Drop City Warehouse'</i> stage</p>
                    <ul style="color: red; margin: 10px">
                        <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>
                    </ul>
                </template>
            </div>

            <div v-if="truckOrderDetail.InternalStatus.id === Constants.internalStatus.atDestinationCityWarehouse">
                <Button @click.stop="completeTruckOrder(truckOrderDetail.id)" :loading="loader1">
                    <span v-if="!loader1">Complete</span>
                    <span v-else>Loading...</span>
                </Button>
            </div>
         </template>
            <div slot="footer">
                <Button style="background: #999999; color: white;font-weight: bolder" @click="changeStatusPopup=false">
                    CANCEL</Button>
            </div>
        </Modal>

        <Modal v-model="confirmDialog" title="Confirmation" draggable>
            <p>Are You sure want to update field {{confirmObj.prop}}?</p>
            <p>from {{confirmObj.oldValue}}</p>
            <p>to {{confirmObj.newValue}}</p>
            <div slot="footer">
                <Button type="primary" style="font-weight: bolder" :loading="updateRecord_loader"
                        @click="updateRecord(row, confirmObj.prop, confirmObj.id?confirmObj.id:confirmObj.newValue)">
                    <span v-if="!updateRecord_loader">OK</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button style="background: #999999; color: white;font-weight: bolder" @click="revertChange(confirmObj.row, confirmObj.prop, confirmObj.oldValue)">
                    CANCEL</Button>
            </div>
        </Modal>

        <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"></manage-order>
    </div>
</template>

<script>
    import { HotTable, HotColumn } from '@handsontable/vue'
    import Handsontable from 'handsontable'
    import {GET_TRUCK_ORDER_BY_ID} from "../../graphql/queries/truckOrders"
    import {SUBSCRIBE_ORDERS_BY_TRUCK_ORDER_ID, SUBSCRIBE_TRUCK_ORDER_BY_ID} from "../../graphql/subscription/truckOrders"
    import {UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID, VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID}
            from "../../graphql/queries/truckOrders"
    import {generate_UPDATE_ORDER_DATA} from '../../graphql/mutations/orders'
    import moment from 'moment'
    import {Constants} from '../../Constants/Constant'
    import {calculateTotalWeightOfOrders} from "./Settings"
    import {orderPriorityColors} from "../ExcelFormattedOrders/Settings";
    import ManageOrder from "../Manage Order/ManageOrder";
    import jsPDF from "jspdf";

    export default {
        name: "TruckOrderDetail",
        components: {ManageOrder, HotTable, HotColumn },
        provide() {
            return {
                getManageOrderDrawer: () => this.manageOrderDrawer,
                setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
                getOrder: () => this.order,
                closeAssignVehicleDialog: (data) => { },
            }
        },
        apollo: {
            $subscribe: {
                orders: {
                    query: SUBSCRIBE_ORDERS_BY_TRUCK_ORDER_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            truckOrderId: this.$route.params.id
                        }
                    },
                    result ({ data }) {
                        this.orders = data.orders
                        this.prepareSheetData(data.orders)
                        this.prepareArrayThenEvaluateWt(data.orders)
                    },
                },
              truckOrderDetail: {
                    query: SUBSCRIBE_TRUCK_ORDER_BY_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            truckOrderId: this.$route.params.id
                        }
                    },
                    result ({ data }) {
                      this.truckOrderDetail = data.truckOrderDetail[0]
                      // this.stage = data.truckOrderDetail[0].InternalStatus?.id
                    },
                }
            },
            truckOrderDetail: {
                query: GET_TRUCK_ORDER_BY_ID,
                fetchPolicy: 'network-only',
                skip () {return !this.$route.params.id},
                variables() {
                    return {
                        truckOrderId: this.$route.params.id
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.truckOrderDetail = data.truckOrderDetail[0]
                        if(this.truckOrderDetail.status === 'Completed' ||
                           (this.truckOrderDetail.status === 'InProgress' &&
                             [Constants.internalStatus.onTheWayToDropCityWarehouse,
                               Constants.internalStatus.atDestinationCityWarehouse].includes(this.truckOrderDetail.InternalStatus.id))){
                          let colIndexToHide = this.columns.length - 1;
                          this.hotSettings.hiddenColumns = {columns: [colIndexToHide]};
                        }
                        // this.stage = data.truckOrderDetail[0].InternalStatus?.id
                    }
                }
            },
        },
        data: function () {
            return{
                Constants: Constants,
                moment: moment,
                userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
                truckOrderDetail: null,
                orders: [],
                totalWtOfOrders: 0,
                changeStatusPopup: false,
                loader1: false,
                errMessages: [],
                manageOrderDrawer: false,
                orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                currentOrderStatus: '',
                order: '',
                viewPath: '',
                columns: [
                    //table_key_intermediate
                    {
                        title: 'Created On',
                        data: 'createdAt',
                        type: 'date',
                        dateFormat: 'DD MMM \'YY hh:mm A'
                    },
                    {
                        title: 'Updated On',
                        data: 'updatedAt',
                        type: 'date',
                        dateFormat: 'DD MMM \'YY hh:mm A'
                    },
                    {
                        title: 'Pickup<br> Date',
                        data: 'orders_pickupDate',
                        type: 'date', dateFormat: 'DD/MM/YYYY'
                    },
                    {
                        title: 'ERP Order No',
                        data: 'orderNumber',
                        renderer: this.orderNumberRenderer
                    },
                    {
                        title:'Status',
                        data: 'internalStatus',
                    },
                    {
                        title:'Comment',
                        data: 'comment'
                    },
                    {
                        title:'LR No.',
                        data: 'orderDetails_lrName_lrObject'
                    },
                    {
                        title:'Client Name',
                        data: 'clientName'
                    },
                    {
                        title:'Pickup Point',
                        data: 'pickupPartyName'
                    },
                    {
                        title:'Drop Point',
                        data: 'dropPartyName'
                    },
                    {
                        title:'Company',
                        data: 'companyName'
                    },
                    {
                        title:'Total<br> Weight',
                        data: 'kg',
                        type: 'numeric'
                    },
                    {
                        title:'Order<br> Details',
                        data: 'boxes'
                    },
                    {
                        title:'Eway Bill No',
                        data: 'orderDetails_ewayBillNo',
                    },
                    {
                        title:'Unlink<br>Order',
                        data: 'unlink',
                        renderer: this.unlinkOrderRenderer
                    }
                ],
                hotSettings: {
                    data: null,
                    readOnly: true,                             //default all cells readOnly
                    hiddenColumns: {columns: []},
                    fillHandle: false,
                    copyPaste: false,
                    licenseKey: "non-commercial-and-evaluation",
                    // rowHeaders: true,
                    autoRowSize: false,
                    autoColumnSize: false,
                    colWidths: [120, 120, 110, 145, 145, 180, 100, 145, 145, 145, 145, 100, 100, 130],
                    className: "htCenter htMiddle",
                    filters: true,
                    dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
                    columnSorting: { sortEmptyCells: true },
                    afterChange: (changes, source) => {
                        if(changes){
                            changes.forEach(([row, prop, oldValue, newValue]) => {
                                let col = this.$refs.hotTableComponent.hotInstance.propToCol(prop)
                                if(source === 'revert' || oldValue === newValue || this.columns[col].hasOwnProperty('component')) return
                                this.confirmObj = {row: row, prop: prop, oldValue: oldValue, newValue: newValue}
                                console.log('oldValue', oldValue, 'newValue', newValue, source)
                                this.confirmDialog = true
                            });
                        }
                    },
                },
                confirmDialog: false,
                confirmObj: {},
                updateRecord_loader: false
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods:{
            orderNumberRenderer(instance, td, row, col, prop, value, cellProperties) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);
                let priority = instance.getDataAtRowProp(row, 'priority')                               //prop name 'priority'

                td.innerHTML = value.substring(0, 9) + '<p>' + value.substring(9, value.length) + '</p>'

                if(orderPriorityColors[priority]){
                    td.style.color = orderPriorityColors[priority]
                }
                td.classList.add('order-num-txt')
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let order = this.orders[pRow]
                let self = this
                td.onclick = function() {
                    self.editOrder(order)
                }
            },
            editOrder(order){
                this.orderId = order.id;
                this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
                this.order = order;
                this.currentOrderStatus = order.internalStatus.id;
                this.manageOrderDrawer = true;
            },
            unlinkOrderRenderer(instance, td, row, col, prop, value, cellProperties) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);

                td.style.color = 'red'
                td.classList.add('order-num-txt')
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let order = this.orders[pRow]
                let self = this
                td.onclick = function() {
                    self.$Modal.confirm({
                        title: 'Confirmation',
                        content: '<p>Are You sure want to unlink Order ?</p>',
                        loading: true,
                        onOk: () => {
                            self.unlinkTruck(order.id, order.orderDetails.id, order.internalstatus, self.$Modal)
                        }
                    });
                }
            },
            unlinkTruck(orderId, orderDetailId, stage, callback){
                let obj = { transportVehicleAssignId: null}
                this.updateRecord_common(orderDetailId, obj, 'orderDetails', 'loader1')

                /* -------- Change Order status to 'In Process Of Departure' --------- */
                if(stage === Constants.internalStatus.waitingForDeparture||
                    stage === Constants.internalStatus.atDestinationCityWarehouse||
                    stage === Constants.internalStatus.onTheWayToDropCityWarehouse) {

                    obj = { internalstatus: Constants.internalStatus.inProcessOfDeparture, lastStageUpdatedOn : moment().format(),
                            lastStageUpdatedBy : this.userObj.user.id}
                    this.updateRecord_common(orderId, obj, 'orders', 'loader1')
                }
                /* ----------------x--------------------x---------------x------------- */
                callback.remove();
            },
            openChangeStatusPopup(){
                this.errMessages = []
                if(this.truckOrderDetail.status !== 'Completed'){
                    this.changeStatusPopup = true
                }
            },
            prepareSheetData(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        createdAt: moment(curnt.createdAt).format('DD MMM \'YY hh:mm A'),
                        updatedAt: moment(curnt.updated_at).format('DD MMM \'YY hh:mm A'),
                        orders_pickupDate: moment(curnt.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                        orderNumber: curnt.orderNumber,
                        internalStatus: curnt.internalStatus.name,
                        comment: curnt.notes.length?curnt.notes[0].note:'',
                        clientName: curnt.clientobject.name,
                        pickupPartyName: curnt.orderDetails&&curnt.orderDetails.pickupPoint&&curnt.orderDetails.pickupPoint.pickupPartyId?
                            curnt.orderDetails.pickupPoint.pickupPartyName:curnt.pickuppartyobject.name,
                        dropPartyName: curnt.orderDetails&&curnt.orderDetails.dropPoint&&curnt.orderDetails.dropPoint.dropPartyId?
                            curnt.orderDetails.dropPoint.dropPartyName:curnt.droppingpartyobject.name,
                        companyName: curnt.pickuppartyobject.name,
                        kg: curnt.materials.kg,
                        boxes: curnt.materials.boxes,
                        orders_note: curnt.note?curnt.note:'-',
                        orderDetails_lrName_lrObject: curnt.orderDetails&&curnt.orderDetails.lrObject?curnt.orderDetails.lrObject.lrName:'',
                        orderDetails_ewayBillNo: curnt.orderDetails&&curnt.orderDetails.ewayBillNo?curnt.orderDetails.ewayBillNo:'-',
                        priority: curnt.priority,
                        internalStatusId: curnt.internalstatus,
                        unlink: 'unlink'
                    }
                    mainArr.push(curnt.obj)
                })
                this.hotSettings.data = mainArr
            },
            async updateRecord(row, prop, newValue){
                this.updateRecord_loader = true
                let hotInstance = this.$refs.hotTableComponent.hotInstance
                let pRow = hotInstance.toPhysicalRow(row)                        //When accessing original array
                let obj = {}, id = '', record = this.orders[pRow];
                let [table, key, intermediate] = prop.split('_')                                               //eg. orderDetails_lrName_lrObject

                if(!intermediate){
                    obj[key] = newValue
                }

                switch(key){
                    case 'pickupDate': obj[key] = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        break
                    case 'lrName':  obj[intermediate] = record[table][intermediate]
                        obj[intermediate][key] = newValue
                        obj[intermediate]['islrReady'] = true
                        break
                }

                switch(table){
                    case 'orders': id = record.id
                        break
                    case 'orderDetails': id = record.orderDetails.id
                        break
                }

                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: {id: id, obj: obj},
                })
                if (response.data) {
                    this.updateRecord_loader = false
                    this.$Message.success('Field ' +key+ ' updated successfully!')
                    this.confirmDialog = false
                    // this.$apollo.queries.orders.refetch()
                }
            },
            revertChange(row, prop, oldValue){
                this.$refs.hotTableComponent.hotInstance.setDataAtRowProp(row, prop, oldValue, 'revert')
                this.confirmObj = {}
                this.confirmDialog = false
            },
            prepareArrayThenEvaluateWt(arr){
                arr = arr.map((obj) => {return {order: obj}})
                this.totalWtOfOrders = calculateTotalWeightOfOrders(arr)
            },
            getColor(status){
                let color = ''
                if(status === 'InProgress') {
                    color = 'orange'
                }else if(status === 'Completed'){
                    color = 'green'
                }else if(status === 'Cancel'){
                    color = 'red'
                }
                return color
            },
            onWayToDropCityWarehouse(truckOrderId){
                let stageId = Constants.internalStatus.waitingForDeparture
                let updateBy_stageId = Constants.internalStatus.onTheWayToDropCityWarehouse
                this.verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, this.updateOrdersStatusUsingTruckOrderId, updateBy_stageId)
            },
            onAtDestinationCityWarehouse(truckOrderId){
                let stageId = Constants.internalStatus.onTheWayToDropCityWarehouse
                let updateBy_stageId = Constants.internalStatus.atDestinationCityWarehouse
                this.verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, this.updateOrdersStatusUsingTruckOrderId, updateBy_stageId)
            },
            async verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, callback, updateBy_stageId){
                this.loader1 = true
                let response = await this.$apollo.query({
                    query: VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID,
                    fetchPolicy: 'network-only',
                    variables: {
                        truckOrderId: truckOrderId,
                        stageId: stageId
                    }
                })
                if(response.data.orders.length){
                    this.errMessages = response.data.orders.map((obj) => obj.orderNumber)
                    this.loader1 = false
                }else{
                    callback(truckOrderId, updateBy_stageId)
                }
            },
            async updateOrdersStatusUsingTruckOrderId(truckOrderId, updateBy_stageId){
                let response = await this.$apollo.mutate({
                    mutation: UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID,
                    variables: {
                        truckOrderId: truckOrderId,
                        stageId: updateBy_stageId,
                        lastStageUpdatedOn : moment().format(),
                        lastStageUpdatedBy : this.userObj.user.id
                    }
                })
                if(response.data){
                    this.loader1 = false
                    this.$Message.success('Multiple Orders updated successfully!')
                    this.changeStatusPopup = false
                    // this.$apollo.queries.orders.refetch()
                    // this.$apollo.queries.truckOrderDetail.refetch()
                }
            },
            completeTruckOrder(id){
                let obj = {status: 'Completed'}
                this.updateRecord_common(id, obj, 'truckOrders', 'loader1')
            },
            async updateRecord_common(id, obj, table, loaderStr){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    this.changeStatusPopup = false
                    // this.$apollo.queries.truckOrderDetail.refetch()
                }
            },
            exportTruckDetailOrdersCSV(){
              let exportPlugin = this.$refs.hotTableComponent.hotInstance.getPlugin('exportFile');
              let str = exportPlugin.exportAsString('csv', {
                columnHeaders: true,
                filename: 'TruckDetail_Orders_' + moment().format('DD_MMM_YYYY_HH_mm'),
              });

              let json = {
                'Truck Order Number': this.truckOrderDetail.truckOrderNumber,
                'Booking Date': this.truckOrderDetail.bookingDate,
                'Route': this.truckOrderDetail.fromCity + ' - ' + this.truckOrderDetail.toCity,
                'Vehicle No': this.truckOrderDetail.truck.platNo,
                'Eway Bill No': this.truckOrderDetail.ewayBillNo?this.truckOrderDetail.ewayBillNo:'-',
                'Committed Wt': this.truckOrderDetail.commitedWeight?this.truckOrderDetail.commitedWeight:'-',
                'Rate': this.truckOrderDetail.price?this.truckOrderDetail.price:'-',
                'LR Comm': this.truckOrderDetail.lrCommision?this.truckOrderDetail.lrCommision:'-',
                'Appro. Payment': (this.truckOrderDetail.commitedWeight*this.truckOrderDetail.price/1000)-this.truckOrderDetail.lrCommision,
                'Driver Name': this.truckOrderDetail.driverDetail.name,
                'Driver Nobile': this.truckOrderDetail.driverDetail.mobile,
                'Transporter': this.truckOrderDetail.Transporter.name,
                'Total Orders': this.orders.length,
                'Status': this.truckOrderDetail.InternalStatus.name,
                'Total/Committed Wt': this.totalWtOfOrders + ' / ' + this.truckOrderDetail.commitedWeight + ' ('+
                                      Math.abs(this.totalWtOfOrders - this.truckOrderDetail.commitedWeight) + ')'
              }
              str = str.replace(/<\/?[^>]+(>|$)/g,"") + '\n\n';        //Remove html tags if any
              Object.keys(json).forEach((key) => {
                str = str + key + ',' + json[key] + '\n';
              });

              let blob = new Blob([str], {type: 'text/plain'});
              const a = window.document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = 'TruckDetail_Orders_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            },
            exportTruckDetailOrdersPDF(){
              let hObj = {id: '', name: '', prompt: '', width: 50, align: "center", padding: 0}
              let headers = [
                {...hObj, name: 'orders_pickupDate', prompt:'Pickup Date', width:50},
                {...hObj, name: 'orderNumber', prompt:'ERP Order No', width:70},
                {...hObj, name: 'internalStatus', prompt:'Status', width:100},
                {...hObj, name: 'comment', prompt:'Comment'},
                {...hObj, name: 'clientName', prompt:'Client Name'},
                {...hObj, name: 'pickupPartyName', prompt:'Pickup Point'},
                {...hObj, name: 'dropPartyName', prompt:'Drop Point'},
                {...hObj, name: 'companyName', prompt:'Company'},
                {...hObj, name: 'kg', prompt:'Total Wt' , width:40},
                {...hObj, name: 'boxes', prompt:'Order details'},
                {...hObj, name: 'orders_note', prompt:'Order Note'},
                {...hObj, name: 'orderDetails_lrName_lrObject', prompt:'LR No'},
                {...hObj, name: 'orderDetails_ewayBillNo', prompt:'Eway Bill No'},
              ];

              let data = JSON.parse(JSON.stringify(this.hotSettings.data));    //get data from hotSettings.data

              let doc = new jsPDF({orientation: "landscape", format:'a2'});
              doc.table(1, 1, data, headers, { autoSize: false, fontSize: 14});
              doc.save('TruckDetail_Orders_' + moment().format('DD_MMM_YYYY_HH_mm'));
            }
        },
        mounted(){
            // setTimeout(() => {
            //     this.$apollo.queries.orders.skip = false
            // }, 500)

        }
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }
    .filterInput{
        width: 80%;
    }
    .plus-value{
        color: green;
    }
    .minus-value{
        color: red;
    }
</style>
<style>
    .order-num-txt:hover {
        text-decoration: underline;
    }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
